export default {
  name: 'error-messages',
  props: ['error'],
};
